export const SUBMIT_FORM_KEY = "@@core.forms/SUBMIT_FORM";
